import { memo } from 'react';

import { useAllContentActions } from '~/components/AllContent/hooks/useAllContentActions';
import { PrivateView } from '~/components/PrivateGallery/PrivateView';
import { SearchPageGalleryView } from '~/components/v2/components/search/SearchPageGalleryView';
import { SearchPageTableView } from '~/components/v2/components/search/SearchPageTableView';
import { useScrollElementContext } from '~/providers/ScrollElementProvider';

export const SearchPageContent = memo(() => {
  const { scrollElementRef } = useScrollElementContext();
  const { options } = useAllContentActions({ trackLocation: 'gallery-context-menu' });

  return (
    <PrivateView
      galleryView={<SearchPageGalleryView />}
      tableView={<SearchPageTableView scrollElementRef={scrollElementRef} />}
      contextMenuOptions={options}
    />
  );
});

SearchPageContent.displayName = 'SearchPageContent';
